import React, {useEffect} from 'react';
import {
	useLazyGetXReportQuery,
	useLazyGetZReportListQuery,
	useLazyGetZReportQuery,
} from '../../redux/DepotSlice/depotCashierApi';
import s from './ReportPage.module.css';
import {Link, useParams} from 'react-router-dom';
import PreLoaderComponent from '../../assets/Animations/PreLoaderComponent/PreLoaderComponent';
import {useTranslation} from 'react-i18next';

const ReportPage: React.FC = () => {
	const {type, id} = useParams();
	const {t} = useTranslation();
	const [triggerX, xReport] = useLazyGetXReportQuery();
	const [triggerZ, zReport] = useLazyGetZReportQuery();
	const [triggerZList, zReportList] = useLazyGetZReportListQuery();

	useEffect(() => {
		if (!type || !id) return;

		switch (type) {
			case 'x-report':
				triggerX(id);
				break;
			case 'z-report':
				triggerZ(id);
				break;
			case 'z-report-list':
				triggerZList();
				break;
			default:
				console.warn(`Unknown report type: ${type}`);
		}
	}, [id, type]);

	const isLoading =
		xReport.isLoading || zReport.isLoading || zReportList.isLoading;
	const data = xReport.data || zReport.data;
	const dataList = zReportList.data;

	return (
		<main className={`page`}>
			<div className="container">
				<div className="page__content">
					{!isLoading && data && type !== 'z-report-list' ? (
						<div dangerouslySetInnerHTML={{__html: data.htmlreport}} />
					) : dataList && !isLoading ? (
						<table className={s.table}>
							<thead className={s.tableHeader}>
								<tr className={s.head}>
									<th>{t('Касир')}</th>
									<th>{t('Дата звіту')}</th>
									<th>{t('дія')}</th>
								</tr>
							</thead>
							<tbody>
								{dataList.reports?.map((item) => (
									<tr key={item.id}>
										<td>{item.cashier_name}</td>
										<td>{item.report_date}</td>
										<td>
											<Link to={`/report-page/z-report/${item.id}`}>
												{t('Відкрити')}
											</Link>
										</td>
									</tr>
								))}
							</tbody>
						</table>
					) : (
						<PreLoaderComponent type={'gallery'} size={'big'} />
					)}
				</div>
			</div>
		</main>
	);
};

export default ReportPage;
